<template>
  <v-container fluid>
    <!-- style="margin-top: -12px;"> -->
    <v-row v-if="tableConfig && (tableConfig.moduleLink || tableConfig.search || tableConfig.menu)">
      <div
        class="d-flex align-center justify-space-between pa-2 mt-2"
        style="width: 100%; height: 72px;"
      >
        <SearchPanel
          v-on:change="onFilterChange"
          :config="childrenConfig"
          :context="childrenContext"
        ></SearchPanel>
        <div
          v-if="tableConfig && tableConfig.moduleLink"
          align="right"
          style="padding: 6px; margin-right:10px;"
        >
          <a :href="tableConfig.moduleLink.href">{{st(tableConfig.moduleLink.title)}}</a>
        </div>
        <div
          v-if="tableConfig && tableConfig.menu && tableConfig.menu.length>0"
          align="right"
          style="padding: 6px; margin-right:10px;"
        >
          <MenuPanel
            v-on:menu-selected="onMenuSelected"
            :config="childrenConfig"
            :context="childrenContext"
          ></MenuPanel>
        </div>
      </div>
    </v-row>
    <ExportXlsx
      ref="exportXlsx"
      style="visibility:hidden;"
      :data="data"
      :columns="headers"
      :fileName="'fundattio_export'"
      :sheetName="'fundattio'"
    ></ExportXlsx>
    <v-row style="width:100%; margin: -12px 0;">
      <v-data-table
        :loading="isLoading"
        :disableFiltering="true"
        fixed-header
        :headers="headers"
        :class="tableConfig.onRowSelect?'row-pointer':''"
        ref="dataTable"
        :loading-text="$t('common.table.loading')"
        :no-data-text="$t('common.table.no_data')"
        :no-results-text="$t('common.table.no_results')"
        :options.sync="options"
        :items="data"
        :fixedHeader="true"
        :height="tableHeight"
        style="width: 100%;"
        :footer-props="{
							'items-per-page-text': $t('common.table.items_per_page'),
							'items-per-page-all-text': $t('common.table.items_per_page_all'),
							'items-per-page-options': itemsPerPageList,
						}"
        @click:row="onRowSelected"
      >
        <template v-slot:[`item.composite_assessment_modules`]="{ item }">
          {{ getAssessmentModules(item.modules) }}
        </template>
        <template v-slot:[`item.composite_assessment_status`]="{ item }">
          <span :style="'color: ' + getAssessmentStatusColor(item.status)">{{ getAssessmentStatusText(item.status) }}</span>
        </template>

        <!--<template v-slot:[`item.download`]="{ item }">
          <v-btn icon @click.stop="downloadItem(item)">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>-->

        <template v-slot:[`item.menu`]="{ item }">
          <MenuPanel
            :compact="true"
            :config="{ menu:tableConfig.rowMenu}"
            :context="item"
            @menu-selected="onMenuSelected($event, item)"
          ></MenuPanel>
        </template>
      </v-data-table>
    </v-row>

    <v-tooltip left v-if="tableConfig && tableConfig.onAddItem">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          fixed
          bottom
          right
          fab
          color="#C3271A"
          v-bind="attrs"
          v-on="on"
          @click="onAddItem()"
        >
          <v-icon style="color: #ffffff;">mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{st(tableConfig.onAddItem.label)}}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import ExportXlsx from '../common/ExportXlsx.vue';
import SearchPanel from './SearchPanel.vue';
import MenuPanel from './MenuPanel.vue';
import api from '../../api/humanway.js';
import BaseModule from '../common/BaseModule.js';
import CommonFormatter from '../common/CommonFormatter.js';
import { EventBus } from './../util/event-bus.js';

export default {
  name: "TableWidget",
  mixins: [BaseModule, CommonFormatter],
  components: {
    SearchPanel,
    ExportXlsx,
    MenuPanel,
  },
  props: ["config", "context"],

  data() {
    return {
      isLoading: true,
      options: {},
      optionsByModules: {},
      itemsPerPageList: [20, 50, 100],
      headers: [],
      data: [],
      tableConfig: {},
      //serverItems: 10,
      tableHeight: undefined,
      childrenContext: {},
      childrenConfig: {},
      filters: [],
			moduleFormsFilterInitialized: false,
			moduleFormSubmissionsFilterInitialized: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.childrenConfig = this.config.fields
        ? JSON.parse(this.config.fields)
        : {};
      this.childrenContext = this.context;
      this.update();
    });
  },
  methods: {
    responsesStatusColor(current, expected) {
			if (expected === 0) {
				return '#F44336';
			}
      return current < expected ? '#21A6E7' : '#3BA70C';
    },
    responsesStatusText(current, expected) {
			if (expected === 0) {
				return this.$t('modules.form.table.status-not_send', [current, expected]);
			}
      return current < expected
        ? this.$t('modules.form.table.status-pending', [current, expected])
        : this.$t('modules.form.table.status-completed', [current, expected]);
    },
    getRowMenu() {
      let menu = this.tableConfig.rowMenu;
      return { menu: menu ? menu : [] };
    },
    onMenuSelected(item) {	
      if (item.mode === "CORE") {
				this.exportData();
      } else {
        EventBus.$emit("widget-data-click", {
          mode: item.mode,
          type: item.type,
          action: item.action,
          payload: item.payload,
        });
      }
    },
    onFilterChange(newFilters) {
			// Guardamos el filtro actualizado en el módulo
      this.filters[this.config.id] = newFilters;

			// Cuando los filtros se actualizan, reseteamos la paginación si procede; en caso contrario, forzamos la recarga de datos
			if (this.optionsByModules[this.config.id].page != 1) {
				this.optionsByModules[this.config.id].page = 1;

				// Nos guardamos los cambios de la configuración de la tabla en el módulo que toca, forzando la recarga de datos
				this.options = this.optionsByModules[this.config.id];
			} else {
				this.loadData();
			}

			console.log(`onFilterChange() called! [ config.id: ${this.config.id} - options: ${JSON.stringify(this.optionsByModules[this.config.id])} ]`);
    },
    onAddItem() {
      if (!this.tableConfig.onAddItem) {
        return;
      }
      EventBus.$emit("widget-data-click", {
        mode: this.tableConfig.onAddItem.mode,
        type: this.tableConfig.onAddItem.type,
        action: this.tableConfig.onAddItem.action,
        payload: null,
      });
    },
    onRowSelected(item) {
      if (!this.tableConfig.onRowSelect) {
        return;
      }
      EventBus.$emit("widget-data-click", {
        mode: this.tableConfig.onRowSelect.mode,
        type: this.tableConfig.onRowSelect.type,
        action: this.tableConfig.onRowSelect.action,
        payload: item[this.tableConfig.onRowSelect.payload],
      });
    },
    loadData() {
      const me = this;
      if (!me.config || !me.config.fields) {
        return;
      }
      me.isLoading = true;
      this.tableConfig = JSON.parse(me.config.fields);
      const fields = this.tableConfig.headers
        ? this.tableConfig.headers
        : this.tableConfig;
      me.headers = [];

      for (var k in fields) {
        let item = fields[k];
        item["value"] = item["field"];
        item["text"] = this.$t(item["label"]);
        item["desc"] = this.$t(item["desc"]);
        item["label"] = this.$t(item["label"]);

        me.headers.push(item);
      }

      if (this.tableConfig.rowMenu && this.tableConfig.rowMenu.length > 0) {
				if (this.tableConfig.rowMenu.length > 0) {
					let item = {
						value: "menu",
						sortable: false,
						width: "20px",
						exportIgnore: true,
					};
					me.headers.push(item);
				}
      }

      const { sortBy, sortDesc, page, itemsPerPage } = this.optionsByModules[this.config.id];

      let queryContext = {
        sortBy: sortBy.length > 0 ? this.translateSortBy(sortBy[0]) : null,
        sortDesc: sortDesc.length > 0 ? sortDesc[0] : null,
				offset: (page - 1) * itemsPerPage,
        count: itemsPerPage,
        filters: this.filters[this.config.id] ? this.filters[this.config.id] : []
      };

      api.getModuleData(
        this.config.id,
        queryContext,
        (res) => {
          me.isLoading = false;
          me.addCustomData(me, res);
          me.data = me.formatData(me, res);
          me.fixLayout(me);
          //me.serverItems = (page-1) * itemsPerPage + res.length + (itemsPerPage == res.length?1:0)
        },
        (err) => {
          alert(err);
          this.isLoading = false;
        }
      );
    },
    translateSortBy(field) {
      if (field === 'composite_assessment_modules'){
				return 'modules';
			}
			if (field === 'composite_assessment_status'){
				return 'status';
			}
      return field;
    },
    exportData() {
      this.$refs.exportXlsx.$el.click();
    },
    update() {
      this.loadData(this);
    },
    fixLayout(vm) {
      this.$nextTick(() => {
        vm.tableHeight = window
          .getComputedStyle(vm.$refs.dataTable.$el, null)
          .getPropertyValue("max-height");
      });
    },
		/*getAssessmentModules(modules) {
			let text = '';

			const m = modules.split(',');

			for (let i = 0; i < modules.length; i++) {
				switch (m[i]) {
					case '1':
						text += this.$t('common.assessment.modules.1');
						break;
					case '2':
						text += this.$t('common.assessment.modules.2');
						break;
				}
				
				if (i < modules.length- 2) {
					text += ', ';
				}
			}

			return text;
		},*/
    /*getAssessmentStatusColor(status) {
			let color = '';

			switch (status) {
				case this.constants.AS_PENDING_STATUS:
					color = '#21A6E7';
					break;
				case this.constants.AS_IN_PROGRESS_STATUS:
					color = '#FF9800';
					break;
				case this.constants.AS_FINISHED_STATUS:
					color = '#3BA70C';
					break;
			}

      return color;
    },
    getAssessmentStatusText(status) {
			let text = '';

			switch (status) {
				case this.constants.AS_PENDING_STATUS:
					text = this.$t('common.assessment.status.pending');
					break;
				case this.constants.AS_IN_PROGRESS_STATUS:
					text = this.$t('common.assessment.status.in_progress');
					break;
				case this.constants.AS_FINISHED_STATUS:
					text = this.$t('common.assessment.status.finished');
					break;
			}

      return text.toUpperCase();
    },*/
  },
  watch: {
    options: {
      handler() {
				// Nos guardamos los cambios de la configuración de la tabla en el módulo que toca
        this.optionsByModules[this.config.id] = { ...this.options };
        console.log(`options changed! [ config.id: ${this.config.id} - options: ${JSON.stringify(this.optionsByModules[this.config.id])} ]`);
        this.loadData();
      },
      deep: true,
    },
    config: function (config) {
      this.$nextTick(() => {
        this.data = [];
        this.childrenConfig = config.fields ? JSON.parse(config.fields) : {};
        console.log(this.childrenConfig);
      });
    },
    context: function (context) {
      this.$nextTick(() => {
        this.childrenContext = context;
        this.data = [];

        // Pasamos al contexto los filtros que tiene el módulo
        this.childrenContext.filters = this.filters[this.config.id] ? this.filters[this.config.id] : [];

        // Al cambiar de módulo, si no existe la configuración de la tabla, la creamos; si existe, reseteamos la paginación
        if (!this.optionsByModules[this.config.id]) {
					this.optionsByModules[this.config.id] = {
						sortBy: [],
						sortDesc: [],
						page: 1,
						itemsPerPage: this.itemsPerPageList[0]
					};
				} else {
					this.optionsByModules[this.config.id].page = 1;
				}

        // Nos guardamos los cambios de la configuración de la tabla en el módulo que toca, forzando la recarga de datos
        this.options = this.optionsByModules[this.config.id];

        console.log(`context changed! reset to page 1 [ config.id: ${this.config.id} - options: ${JSON.stringify(this.optionsByModules[this.config.id])} ]`);
      });
    },
  },
};
</script>

<style scoped>
.v-data-footer {
  left: 200px;
}
</style>